import { ReactComponent } from './hourglass.svg';
import { createIconFromSvg } from '../icons';

export const Hourglass = createIconFromSvg(ReactComponent);
